export const numberToPx = (value: number) => `${value}px`;
